/* eslint-disable react/prop-types */
import { Card, CardContent } from '@mui/material'

/**
 * CustomCardRoot component that renders a customized Material-UI Card.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {React.ReactNode} props.children - The child elements to be rendered inside the Card.
 * @param {Object} props.rest - Additional props to be spread onto the Card component.
 * @returns {React.Element} A customized Card component with specific styling and layout.
 */
function CustomCardRoot({ children, ...rest }) {
  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '13.75rem',
        height: '7rem',
        background: '#EBEBEB',
        borderRadius: '6px',
        boxShadow: 'none',
        gap: '.5rem',
      }}
      {...rest}
    >
      <CardContent sx={{ padding: '.5rem 1rem' }}>{children}</CardContent>
    </Card>
  )
}

export default CustomCardRoot
